const DATASOURCE_TEXT_TYPES = new Set(['object', 'search_param'])

const isEmptyDesignerValue = (value) =>
  value === null ||
  typeof value === 'undefined' ||
  (typeof value === 'string' && value.trim() === '')

export const getReportDesignerTextPlaceholder = (
  item = {},
  { disabled = false } = {},
) => {
  if (
    disabled ||
    !DATASOURCE_TEXT_TYPES.has(item?.type) ||
    !isEmptyDesignerValue(item?.value)
  ) {
    return ''
  }

  const bindName = `${
    item?.name || item?.fieldName || item?.title || ''
  }`.trim()

  return bindName ? `[${bindName}]` : ''
}
